import { useAuth } from "@/context/AuthContext";

const AV_OPTIONS = [
  { k: "yes", label: "avail.yes", dot: "bg-emerald-400", activeCls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40" },
  { k: "maybe", label: "avail.maybe", dot: "bg-amber-400", activeCls: "bg-amber-500/15 text-amber-400 border-amber-500/40" },
  { k: "no", label: "avail.no", dot: "bg-rose-400", activeCls: "bg-rose-500/15 text-rose-400 border-rose-500/40" },
];

export function AvDot({ status, size = "h-3.5 w-3.5" }) {
  const cls =
    status === "yes" ? "bg-emerald-400" :
    status === "maybe" ? "bg-amber-400" :
    status === "no" ? "bg-rose-400" : "bg-slate-500";
  return <span className={`inline-block rounded-full ${size} ${cls}`} />;
}

export default function AvailabilityButtons({ value, onChange, testidPrefix = "availability" }) {
  const { t } = useAuth();
  return (
    <div className="flex gap-2 flex-wrap">
      {AV_OPTIONS.map((o) => (
        <button
          key={o.k}
          type="button"
          onClick={() => onChange(o.k)}
          data-testid={`${testidPrefix}-${o.k}-button`}
          className={`flex items-center gap-2 px-3 py-1.5 lg:px-4 lg:py-2 rounded-full border text-xs lg:text-sm font-medium transition-all ${
            value === o.k ? o.activeCls : "border-app t-secondary hover:bg-white/5"
          }`}
        >
          <span className={`h-2.5 w-2.5 rounded-full ${o.dot}`} />
          {t(o.label)}
        </button>
      ))}
    </div>
  );
}
